import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export const WizardSteps = ({ steps, step, canGo, onGo }) => (
  <ol className="mt-4 flex flex-wrap gap-2" aria-label="Setup steps">
    {steps.map((s, i) => {
      const on = i === step;
      const done = i < step;
      return (
        <li key={s.short}>
          <button
            type="button"
            disabled={!canGo(i)}
            onClick={() => onGo(i)}
            aria-current={on ? "step" : undefined}
            data-testid={`rc-step-tab-${i}`}
            className={cn(
              "flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50",
              on ? "border-primary bg-primary text-primary-foreground" : done ? "border-primary/40 bg-secondary text-secondary-foreground" : "bg-background text-muted-foreground enabled:hover:text-foreground"
            )}
          >
            <span className={cn("flex h-5 w-5 items-center justify-center rounded-full text-[11px]", on ? "bg-primary-foreground/20" : "bg-muted")}>
              {done ? <Check className="h-3 w-3" /> : i + 1}
            </span>
            {s.short}
          </button>
        </li>
      );
    })}
  </ol>
);
